import { useTranslation } from "react-i18next";
import { Loader, ServiceIcons } from "@monorepo/components";
import { useServiceGroupsQuery } from "@monorepo/services/api/services";
import theme from "@monorepo/styles/theme";
import { Box, Typography } from "@mui/material";

interface IServiceGroupProps {
  group: string;
  onSelectedService: (value: string) => void;
}

export const ServiceGroups: React.FC<IServiceGroupProps> = ({ group, onSelectedService }) => {
  const { data: serviceGroups, isLoading } = useServiceGroupsQuery(group);
  const { t } = useTranslation();

  if (isLoading) {
    return <Loader />;
  }

  if (serviceGroups?.length) {
    return (
      <>
        <Typography variant="h6" component="span">
          {t("service.choose_service")}
        </Typography>
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: "100%",
            gridTemplateRows: "max-content",
            justifyContent: "center",
            overflow: "hidden",
            marginTop: theme.spacing(5),
          }}
        >
          <Box
            sx={{
              width: {
                xs: "100%",
              },
              minWidth: {
                sm: "485px",
              },
              maxWidth: {
                xs: "none",
                sm: "485px",
              },
              justifySelf: "center",
              padding: "6px",
            }}
          >
            {serviceGroups.map(({ id, category_id: categoryId, api_service_name: serviceName }) => (
              <Box
                sx={{
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  padding: "12px",
                  borderRadius: "12px",
                  columnGap: theme.spacing(2),
                  "&:hover,:focus-visible": {
                    outline: 0,
                    color: theme.palette.secondary.main,
                    backgroundColor: theme.palette.shuttleGray.main,
                  },
                }}
                role="button"
                tabIndex={0}
                key={id}
                onKeyPress={() => onSelectedService(id)}
                onClick={() => onSelectedService(id)}
              >
                <ServiceIcons serviceId={categoryId} />
                <Typography component="span">{serviceName}</Typography>
              </Box>
            ))}
          </Box>
        </Box>
      </>
    );
  }

  return null;
};
